import type { FixedLineItem } from '@weft/types';
import { PROMOTION_TYPES } from '@weft/types';
import { LINE_ITEM_TYPES, type LineItem, type PromotionLineItem } from '@weft/types';
import { isCommissionProduct } from '../products-filter';
import { PRODUCT_LINE_ITEM_TYPES } from './line-items-filter-consts';
import { isCommitmentLineItem } from './line-items-filter-implementations';
import type { ProductLineItem } from './line-items-filter-types/product-line-item';

export function filterCommitmentLineItems(lineItems: LineItem[]) {
  return lineItems.filter(isCommitmentLineItem);
}

export function filterProductLineItems(lineItems: LineItem[]): ProductLineItem[] {
  return lineItems.filter(isProductLineItem);
}

export function filterPromotionLineItems(lineItems: LineItem[]): PromotionLineItem[] {
  return lineItems.filter(isPromotionLineItem);
}

export function isCommissionFixedLineItem(lineItem: FixedLineItem) {
  return isCommissionProduct(lineItem.lineItemProduct);
}

export function isPromotionLineItem(lineItem: LineItem): lineItem is PromotionLineItem {
  return lineItem.type === LINE_ITEM_TYPES.Promotion;
}

export function isProductLineItem(lineItem: LineItem): lineItem is ProductLineItem {
  return PRODUCT_LINE_ITEM_TYPES.includes(lineItem.type);
}

export function isPercentagePromotionLineItem({ lineItemPromotion: { promotionModel } }: PromotionLineItem) {
  return promotionModel.promotionType === PROMOTION_TYPES.Percentage;
}

export * from './line-items-filter-implementations';
export * from './line-items-filter-types';